import { render, staticRenderFns } from "./ChildrensPage.vue?vue&type=template&id=0c8937d5&"
import script from "./ChildrensPage.vue?vue&type=script&lang=js&"
export * from "./ChildrensPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports